// extracted by mini-css-extract-plugin
module.exports = {"names":"TokensNames_names__2DFWC","platform":"TokensNames_platform__3hDD7"};